import React, { useId, ReactElement } from "react";
import {InputLabel} from "@App/Components";
import Language from "@Components/Language";

type IconFloatFieldProps = {
  label: string;
  id?: string;
  icon?: string;
  children: ReactElement;
};

export function IconFloatField({
   label,
   id,
   icon = "pi-user",
   children,
  }: IconFloatFieldProps) {

  return (
    <div className="p-inputgroup mb-2">
      <div className="p-inputgroup-addon h-3rem mt-2">
        <i className={`pi ${icon}`}/>
      </div>
      <div className="p-float-label flex-column flex">
        {children}
        <InputLabel
          htmlFor={id}
          style={{
            top: '2rem',
          }}>
          {Language.get(label)}
        </InputLabel>
      </div>
    </div>
  );
}
